import { LOGIN_ROUTE } from "./exclusiveLogin/loginRoutes";

/** 로그인 화면이 로그인 뒤 돌아갈 주소를 받는 쿼리 이름(marketing-auth-pages 「로그인 뒤 돌아갈 주소」) */
export const LOGIN_RETURN_QUERY = "returnTo";
/** 돌아갈 주소가 없거나 받을 수 없는 값이면 종전처럼 홈 */
const DEFAULT_AFTER_LOGIN = "/";
/** 같은 사이트 안 경로 — `/` 로 시작하되 `//`·`/\`(다른 호스트로 해석될 수 있음)는 받지 않는다 */
const SAME_SITE_PATH = /^\/(?![/\\])/;

/** 경로 부분(쿼리·해시 앞, 끝 빗금 뺌) */
const pathnameOf = (path: string) => path.split(/[?#]/)[0].replace(/\/+$/, "");

/** 로그인 화면 자신으로는 돌려보내지 않는다 — 같은 화면으로 옮기면 로그인한 사람이 로그인 화면에 남는다 */
const isReturnablePath = (value: unknown): value is string =>
  typeof value === "string" &&
  SAME_SITE_PATH.test(value) &&
  pathnameOf(value) !== LOGIN_ROUTE;

/** 로그인 뒤 `path`(쿼리·해시 포함)로 돌아오게 하는 로그인 화면 주소 */
export function loginHrefReturningTo(path: string) {
  return { pathname: LOGIN_ROUTE, query: { [LOGIN_RETURN_QUERY]: path } };
}

/**
 * 로그인 화면 쿼리의 `returnTo` 값 → 실제로 갈 곳. 로그인 화면이 아닌 같은 사이트 안 경로만 받고 나머지(없음·바깥
 * 주소·배열·로그인 화면)는 `fallback` 이다. 로그인을 마친 사람은 홈(기본값), 로그인한 채 로그인 화면에 온 사람은 프로젝트
 * 목록으로 간다(marketing-auth-pages 「로그인한 사용자는 인증 화면을 거치지 않는다」).
 */
export function resolveLoginReturnPath(
  value: unknown,
  fallback: string = DEFAULT_AFTER_LOGIN
): string {
  return isReturnablePath(value) ? value : fallback;
}
